import { CustomFieldRendererProps } from "@/components/custom-field/edit/custom-field-edit.type.ts";
import { useDatepickerConfig } from "@/hooks/use-datepicker-config.hook.ts";
import { CustomFieldDate } from "@skailer-com/uikit";

/** Дата в формате и локали текущего сотрудника. */
export function CustomFieldEditDate(props: CustomFieldRendererProps) {
  const datepickerConfig = useDatepickerConfig();

  return <CustomFieldDate {...props} datepicker={datepickerConfig} />;
}
